import { DataObject, Node, Page, Image } from '@07/types';

export class Fylke extends Page {
    subtitle: string;
    content: string;
    background_image: Image = Image as any;
    group_image: Image = Image as any;
    group_title: string;
    group_info: string;
    group_link: string;
    image: Image = Image as any;
    children: number[];

    constructor(data: DataObject, entitytype:string='fylke', grouptype:string='entity', _c:boolean=true) {
        super(data, entitytype, grouptype, false);
        if (_c) this.construct(data);
    }

    construct(data) {
        data.excerpt = data.description;
        super.construct(data);
    }
}

export class Fylkeroversikt extends Node {
    children: Fylke[] = [Fylke as any];

    constructor(data: DataObject, entitytype:string='fylkeroversikt', grouptype:string='entity', _c:boolean=true) {
        super(data, entitytype, grouptype, false);
        if (_c) this.construct(data);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+fylker/types.ts